import "swiper/css";
import "swiper/css/pagination";

import { BaseURL } from "../../config/axios";
import WallImage from "./WallImage";
import React, { useContext, useState } from "react";
import { FavoriteContext } from "../../providers/FavoriteContextProvider";
import { IsInFavorite } from "../../helper/functions";
import { Link } from "react-router-dom";
import { IsInCart, quantityItem } from "../../helper/functions";
import { CartContext } from "../../providers/CartContextProvider";
import Aside from "../../Components/DetailPaint/aside";
import "./favoritesStyle.css"
import ShowMoreHTML from "./ShowMoreHTML";

const Hr = () => (
  <hr
    className="h-[3px] max-w-[40%] mx-auto opacity-35 my-2"
    style={{
      background:
        "linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0.65) 50%, rgba(0, 0, 0, 0) 90%, rgba(0, 0, 0, 0) 100%)",
    }}
  />
);

export default function Article({ Painting, mainImage, setMainImage, width, setWidth, height, setHeight, withFrame }) {
  const { title, body, artist, category, images } = Painting;
  const { state, dispatch } = useContext(FavoriteContext)
  const { state: stateCart, dispatch: dispatchCart } = useContext(CartContext)
  const [zoomLevel, setZoomLevel] = useState(75);
  const [passpartout, setPasspartout] = useState(null)

  const handleZoom = (direction) => {
    setZoomLevel((prevZoomLevel) => {
      let newZoomLevel = prevZoomLevel + direction * 25;
      if (newZoomLevel > 100) newZoomLevel = 100;
      if (newZoomLevel < 10) newZoomLevel = 10;
      return newZoomLevel;
    });
  };
  return (
    <article className=" col-span-8 xl:col-span-9 mb-5 md:mb-0 bg-white border rounded-lg p-5">
      <div className="relative flex flex-col gap-2">
        <div
          className="centerOfParent overflow-hidden max-h-full h-auto shrink-0 max-w-full mx-auto"
          style={{
            width: `${zoomLevel}%`,
            transition: 'width 0.3s ease',
          }}
        >
          <img width={100} height={100}
            src={mainImage || (images[0] && BaseURL + images[0].path)}
            style={{ transition: 'width 0.3s ease' }}
            className="object-contain w-full"
            alt={Painting.title_persian}
          />
        </div>
        <div className="flex items-center gap-3 self-end">
        <div className="centerOfParent flex-wrap gap-3 button-screen">
        {IsInFavorite(state, Painting) ? <button onClick={() => dispatch({ type: "REMOVE_ITEM", payload: Painting.id })} type="button" className="bg-primary text-white rounded-md p-3  flex flex-items-center justify-between gap-3 hover:opacity-80 dislike-button">
          <img alt="favorite" src="/images/art-icon/icon-heart.png" />
        </button>
          : <button onClick={() => dispatch({ type: "ADD_ITEM", payload: Painting })} className="bg-primary text-white rounded-md p-3  flex flex-items-center justify-between gap-3 hover:opacity-80 like-button" type="button">
            <img alt="favorite" src="/images/art-icon/icon-unheart.png"/>
          </button>}
        <WallImage mainImage={mainImage || (images[0] && BaseURL + images[0].path)} size={{ width, height }} />
        {withFrame && (IsInCart(stateCart, Painting) ?
          <div className='flex items-center px-2 py-1 border border-primary rounded justify-between text-primary'>
            <button className='centerOfParent bg-none border-0 py-2 px-1'>
              {quantityItem(stateCart, Painting) < 2 ?
                <svg className="cursor-pointer" onClick={() => dispatchCart({ type: "REMOVE_ITEM", payload: Painting })} stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> :
                <svg className="cursor-pointer" onClick={() => dispatchCart({ type: "DECREASE", payload: Painting })} stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              }
            </button>
            <span className='centerOfParent text-xl my-1 mx-3'>{quantityItem(stateCart, Painting)}</span>
            <button className="centerOfParent bg-none border-0 py-2 px-1" onClick={() => dispatchCart({ type: 'INCREASE', payload: Painting })}>
              <svg className="cursor-pointer" stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            </button>
          </div>
          : <button onClick={() => dispatchCart({ type: "ADD_ITEM", payload: Painting })}
            className="bg-primary text-white rounded-md p-3 flex flex-items-center justify-between gap-3 hover:opacity-80">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"></path></svg>
          </button>)}
        {Painting.audio && <audio className="w-full mt-2 mb-2" controls src={Painting?.audio}></audio>}
      </div>
          
          
          
          <div
            className="centerOfParent cursor-pointer w-8 h-8"
            onClick={() => handleZoom(1)} // Zoom in
          >
            <img alt="zoom in" src='/images/icons/zoom-in.svg' className="w-full h-full object-cover" />
          </div>
          <div
            className="centerOfParent cursor-pointer w-8 h-8"
            onClick={() => handleZoom(-1)} // Zoom out
          >
            <img alt="zoom out" src='/images/icons/zoom-out.svg' className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="md:hidden">
          <Aside {...{ Painting, setMainImage, mainImage, passpartout, setPasspartout, setWidth, setHeight, width, height }} />
        </div>
      </div>

      <div className="bg-[#0000000a] w-[90%] p-4 mx-auto mt-4">
        <div dir='rtl'><span>شناسه تابلو: {Painting?.id}</span></div>
        <div className="text-center ">
          <h2 className="text-primary text-[32px] font-bold">{title}</h2>
          <h1 className="text-primary text-lg font-bold">{Painting?.title_persian}</h1>
          <Hr />
          <Link to={`/artists/${Painting?.artist?.slug}`} className="font-bold text-[17px] break-words">
            {artist?.title}
          </Link>

          <Hr />

          <div className="centerOfParent gap-3">
            <Link to={`/categories/${Painting?.category?.slug}`} className="font-bold text-[17px] text-secondary">
              {category?.title}
            </Link>
          </div>
          <Hr />
          <div className="flex flex-col">
            {Painting.audios.map(a => <audio className="w-full mt-2 mb-2" src={BaseURL + a.file_path} controls ></audio>)}
          </div>
          <Hr />
          <div className="my-4">
            {/* <div className={`text-justify ql-editor`} dangerouslySetInnerHTML={{ __html: body }} /> */}
            <ShowMoreHTML body={body}/>
          </div>
        </div>
      </div>

      <div className="centerOfParent flex-wrap gap-3 mt-3 favorites">
        {/* {IsInFavorite(state, Painting) ? <button onClick={() => dispatch({ type: "REMOVE_ITEM", payload: Painting.id })} type="button" className="bg-primary text-white rounded-md p-3  flex flex-items-center justify-between gap-3 hover:opacity-80">
          <img alt="favorite" src="/images/art-icon/icon-heart.png" />
          <span>حذف کردن تصویر از موارد دلخواه</span>
        </button>
          : <button onClick={() => dispatch({ type: "ADD_ITEM", payload: Painting })} className="bg-primary text-white rounded-md p-3  flex flex-items-center justify-between gap-3 hover:opacity-80" type="button">
            <img alt="favorite" src="/images/art-icon/icon-heart.png" />
            <span>اضافه کردن تصویر به موارد دلخواه</span>
          </button>} */}
        {/* <WallImage mainImage={mainImage || (images[0] && BaseURL + images[0].path)} size={{ width, height }} /> */}
        {withFrame && (IsInCart(stateCart, Painting) ?
          <div className='flex items-center px-2 py-1 border border-primary rounded justify-between text-primary'>
            <button className='centerOfParent bg-none border-0 py-2 px-1'>
              {quantityItem(stateCart, Painting) < 2 ?
                <svg className="cursor-pointer" onClick={() => dispatchCart({ type: "REMOVE_ITEM", payload: Painting })} stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> :
                <svg className="cursor-pointer" onClick={() => dispatchCart({ type: "DECREASE", payload: Painting })} stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              }
            </button>
            <span className='centerOfParent text-xl my-1 mx-3'>{quantityItem(stateCart, Painting)}</span>
            <button className="centerOfParent bg-none border-0 py-2 px-1" onClick={() => dispatchCart({ type: 'INCREASE', payload: Painting })}>
              <svg className="cursor-pointer" stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            </button>
          </div>
          : <button onClick={() => dispatchCart({ type: "ADD_ITEM", payload: Painting })}
            className="bg-primary text-white rounded-md p-3 flex flex-items-center justify-between gap-3 hover:opacity-80">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"></path></svg>
            <span>افزودن به سبد خرید</span>
          </button>)}
        {Painting.audio && <audio className="w-full mt-2 mb-2" controls src={Painting?.audio}></audio>}
      </div>

    </article>
  );
}
